<template>
  <div class="relative flex items-center">
    <input
      ref="searchInput"
      type="text"
      name="query"
      :value="modelValue"
      class="w-full bg-gradient-to-tr from-[#E8F2F8] to-blue-10 px-4 py-[0.8125rem] outline-none ring-offset-0 placeholder:text-blue-dark-700/60"
      :class="small ? 'text-md' : 'text-base'"
      :placeholder="placeholder || $t('search.search_placeholder')"
      @keyup.enter="emit('search', $event.target.value)"
      @input="debouncedTextSearch($event.target.value)"
    />

    <button
      class="absolute right-1 p-4"
      :aria-label="$t('accessibility.apply_text_search')"
      @click="emit('search', $refs.searchInput.value)"
    >
      <SearchIcon class="w-4 text-blue-800" />
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  small: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: [String],
    default: null,
  },
  autoFocus: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: null,
  },
})

const searchInput = ref(null)

const emit = defineEmits(['update:modelValue', 'search'])

function emitTextInput(value) {
  emit('update:modelValue', value)
}

onMounted(async () => {
  if (!props.autoFocus) {
    return
  }

  setTimeout(() => {
    searchInput.value.focus()
  }, 800)
})

const debouncedTextSearch = useDebounceFn(emitTextInput, 500)
</script>
